import { Component } from '@theme/component';
class EhlVisualMenu extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.dialog = this.querySelector('dialog');
    this.addEventListener('click', (event) => {
      const control = event.target.closest('button');
      if (!control) return;
      if (control.hasAttribute('data-open')) {
        this.selectCategory(control.dataset.open);
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      if (control.hasAttribute('data-category')) this.selectCategory(control.dataset.category);
      if (control.hasAttribute('data-close')) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      document.body.style.overflow = this.previousOverflow ?? '';
    }, { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    }, { signal });
  }
  selectCategory(index) {
    this.querySelectorAll('[data-category]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.category === String(index)));
    });
    this.querySelectorAll('.ehl-nav-panel').forEach((panel, i) => { panel.hidden = i !== Number(index); if (!panel.hidden) panel.querySelectorAll('img').forEach(image => { image.loading = 'eager'; }); });
    this.querySelector('.ehl-nav-scroll').scrollTop = 0;
  }
  disconnectedCallback() {
    if (this.dialog?.open) document.body.style.overflow = this.previousOverflow ?? '';
    this.abort?.abort();
    super.disconnectedCallback();
  }
}
if (!customElements.get('ehl-visual-menu')) customElements.define('ehl-visual-menu', EhlVisualMenu);
